module.exports = __webpack_public_path__ + "static/media/modal-deco.dd1ac31e.svg";